import { useEffect, useRef } from 'react';
import { logout } from './auth';

const INACTIVITY_LIMIT = 20*60 * 1000;

export const useInactivityLogout = () => {
  const timer = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {

    const resetTimer = () => {
      if (timer.current) clearTimeout(timer.current);
      console.log('🔄 Timer reseteado');
      timer.current = setTimeout(() => {
        alert("Sesión caducada, por favor vuelva a ingresar"); 
        logout();
      }, INACTIVITY_LIMIT);
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);
};